export const css = {
	titleBlock: '_1a54WhHR',
	' _key': 'afcpe-theme/afcpe/quiz-widgets/quizfolder'
};

export default css;
